import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../shared/shared.module';
import { VivoFiltersComponent } from './vivo-filters.component';
import { StateService } from '../../shared/state/state.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    SharedProviderModule,
    NgbDropdownModule
  ],
  declarations: [VivoFiltersComponent],
  providers: [StateService],
  exports: [VivoFiltersComponent]
})
export class VivoFiltersModule {
}
